import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import LeftNav from '../common/LeftNav';
import TopNav from '../common/TopNav';
import leadleft from "../../assets/img/lead-left.svg";
import prestige from '../../assets/img/prestige.svg';
import estate from "../../../assets/estate.jpg";
import frame from "../../assets/img/frame.png";
import frame1 from "../../assets/img/frame2.png";
import builderprofile1 from "../../assets/img/builderprofile.svg";
import builderprofile2 from "../../assets/img/smallbuilderprofile.svg";
import defaultProfileImg from "../../assets/img/defaultprofile.jpeg";
import locati from "../../assets/img/location.svg";
import edit from "../../assets/img/blueedit.svg";
import close from "../../assets/img/closemodal.svg";
import imageplus from "../../assets/img/imageplus2.svg";
import Toaster from '../../../components/Toaster';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaCalendarAlt, FaChartLine, FaUsers, FaDownload, FaBuilding, FaStar, FaCopy, FaClock, FaChevronRight, FaArrowLeft, FaRegStar } from "react-icons/fa";
import userService from "../../../services/userService";
import crmService from "../../../services/crmService";

// Modal


export default function AccountSettings() {
  const { id: urlAgentId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { partnerData, agentId: stateAgentId } = location.state || {};

  // Use agentId from state first, then from URL params
  const agentId = stateAgentId || urlAgentId;

  // Core state management
  const [loading, setLoading] = useState(true);
  const [agentData, setAgentData] = useState(null);
  const [agentLeads, setAgentLeads] = useState([]);
  const [loadingLeads, setLoadingLeads] = useState(false);
  const [showFullAbout, setShowFullAbout] = useState(false);

  // Review modal states
  const [isAddReviewModalVisible, setAddReviewModalVisible] = useState(false);
  const [isAllReviewsModalVisible, setAllReviewsModalVisible] = useState(false);
  const [starRating, setStarRating] = useState(5);
  const [reviewComment, setReviewComment] = useState('');
  const [submittingReview, setSubmittingReview] = useState(false);
  const [allReviews, setAllReviews] = useState([]);
  const [loadingAllReviews, setLoadingAllReviews] = useState(false);

  // User review state
  const [userExistingReview, setUserExistingReview] = useState(null);
  const [isEditingReview, setIsEditingReview] = useState(false);

  // Legacy UI states (keeping for current design)
  const [show, setShow] = useState(false);
  const [openIndex, setOpenIndex] = useState(0);
  const [profileImage, setProfileImage] = useState(defaultProfileImg);
  const fileInputRef = useRef(null);

  // Toast notification state
  const [toast, setToast] = useState({
    show: false,
    message: '',
    type: 'success'
  });

  const showToast = (message, type = 'success') => {
    setToast({ show: true, message, type });
  };

  const hideToast = () => {
    setToast(prev => ({ ...prev, show: false }));
  };

  const toggleInvoice = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };
  
    // Open file picker
    const handleIconClick = () => {
      fileInputRef.current.click();
    };
  
    // When file selected
    const handleFileChange = (e) => {
      const file = e.target.files[0];
      if (file) {
        const imageUrl = URL.createObjectURL(file);
        setProfileImage(imageUrl);
      }
    };

  // Constants
  const API_BASE_URL = 'https://sandbox.rebax.in';

  // Helper to convert relative paths to full URLs
  const getFullImageUrl = (imagePath) => {
    if (!imagePath) return null;
    if (imagePath.startsWith('http')) return imagePath;
    return `${API_BASE_URL}${imagePath}`;
  };

  // UseEffect for loading data
  useEffect(() => {
    console.log('AgentProfile mounted with:');
    console.log('- urlAgentId:', urlAgentId);
    console.log('- stateAgentId:', stateAgentId);
    console.log('- final agentId:', agentId);
    console.log('- partnerData:', partnerData);
    console.log('- location.state:', location.state);

    if (agentId) {
      loadAgentProfile(agentId);
      loadAgentLeads(agentId);
    } else if (partnerData) {
      // Use partner data directly if no agentId
      setAgentData({
        id: partnerData.partner_id || partnerData.id,
        full_name: partnerData.name || partnerData.agent_name,
        phone: partnerData.phone || partnerData.agent_phone,
        email: partnerData.email || partnerData.agent_email,
        avatar_url: partnerData.avatar_url,
        city: partnerData.city || 'Hyderabad',
        experience: partnerData.experience || '2 years',
        about: partnerData.about || 'Real estate professional',
        partnerships_count: 0,
        registered_leads: partnerData.registered_leads || 0,
        rating: partnerData.rating || 0,
        achievements: partnerData.achievements || [],
        reviews: [],
        total_reviews: 0,
        average_rating: partnerData.rating || 0
      });
      setLoading(false);
      if (partnerData.partner_id) {
        loadAgentLeads(partnerData.partner_id);
      }
    } else {
      console.log('No agentId or partnerData provided');
      // Set some default data to show something
      setAgentData({
        id: 'N/A',
        full_name: 'Agent Name',
        phone: '',
        email: '',
        avatar_url: '',
        city: 'Hyderabad',
        experience: '2 years',
        about: 'Real estate professional',
        partnerships_count: 0,
        registered_leads: 0,
        rating: 0,
        achievements: [],
        reviews: [],
        total_reviews: 0,
        average_rating: 0,
      });
      setLoading(false);
    }
  }, [agentId, partnerData]);

  // API Functions
  const loadAgentProfile = async (id) => {
    try {
      setLoading(true);
      console.log('Loading agent profile for id:', id);
      console.log('userService:', userService);
      console.log('getAgentPublicInfo method available:', typeof userService.getAgentPublicInfo);

      const response = await userService.getAgentPublicInfo(id);
      console.log('Agent profile API response:', JSON.stringify(response, null, 2));

      if (response && response.success && response.data) {
        const agentInfo = response.data.agent || response.data;
        const stats = response.data.statistics || {};
        const reviews = response.data.reviews || [];
        const reviewStats = response.data.review_stats || {};
        const achievements = response.data.achievements || agentInfo.achievements || [];

        console.log('Reviews from API:', reviews.length, 'reviews');

        const data = {
          ...agentInfo,
          partnerships_count: stats.partnerships_count || 0,
          registered_leads: stats.registered_leads || 0,
          total_conversions: stats.total_conversions || 0,
          revoked_count: stats.revoked_count || 0,
          reviews: reviews,
          total_reviews: reviewStats.total_reviews || reviews.length || 0,
          average_rating: reviewStats.average_rating || 0,
          achievements: achievements,
        };

        setAgentData(data);

        // Check if current user has already reviewed this agent
        console.log('🔥 DEBUG - About to call checkExistingUserReview with reviews:', reviews.length);
        checkExistingUserReview(reviews);
        console.log('🔥 DEBUG - Finished calling checkExistingUserReview');

        console.log('Agent profile loaded successfully with', reviews.length, 'reviews');
        console.log('Final agent data:', data);
        console.log('Final average_rating:', data.average_rating);
        console.log('Final total_reviews:', data.total_reviews);
        console.log('Final reviews array:', data.reviews);
      } else {
        console.log('Agent profile API returned no data or failed:', response);
      }
    } catch (err) {
      console.log('Error loading agent profile:', err.message || 'Unknown error');
      // If API fails, use partnerData if available
      if (partnerData) {
        setAgentData({
          id: partnerData.partner_id || partnerData.id,
          full_name: partnerData.name || partnerData.agent_name,
          phone: partnerData.phone || partnerData.agent_phone,
          email: partnerData.email || partnerData.agent_email,
          avatar_url: partnerData.avatar_url,
          city: partnerData.city || 'Hyderabad',
          experience: partnerData.experience || '2 years',
          about: partnerData.about || 'Real estate professional',
          partnerships_count: 0,
          registered_leads: partnerData.registered_leads || 0,
          rating: partnerData.rating || 0,
          achievements: partnerData.achievements || [],
          reviews: [],
          total_reviews: 0,
          average_rating: partnerData.rating || 0
        });
      }
    } finally {
      setLoading(false);
    }
  };

  // Check if current user has already reviewed this agent
  const checkExistingUserReview = (reviews) => {
    try {
      console.log('🔍 DEBUG - checkExistingUserReview function called');
      // Get current user data from localStorage
      const userData = JSON.parse(localStorage.getItem('user') || '{}');
      const currentUserId = userData.id;

      const rawUserData = localStorage.getItem('user');
      console.log('🔍 Debug - Raw localStorage user STRING:', rawUserData);
      console.log('🔍 Debug - Current user data OBJECT:', userData);
      console.log('🔍 Debug - Current user ID:', currentUserId);
      console.log('🔍 Debug - All user keys:', Object.keys(userData));

      // Check specifically for ABC Builders123 in all fields
      let foundABC = false;
      Object.keys(userData).forEach(key => {
        const value = userData[key];
        if (value && typeof value === 'string' && value.includes('ABC Builders123')) {
          console.log(`🔍 DEBUG - FOUND ABC Builders123 in field ${key}:`, value);
          foundABC = true;
        }
      });
      if (!foundABC) {
        console.log('🔍 DEBUG - ABC Builders123 NOT FOUND in any user data field');
      }
      console.log('🔍 Debug - Looking for reviewer_name "ABC Builders123" in user fields');
      console.log('🔍 Debug - Reviews data:', reviews);
      console.log('🔍 Debug - Reviews array length:', reviews ? reviews.length : 0);
      console.log('🔍 Debug - Current user ID exists?', !!currentUserId);

      if (!currentUserId || !reviews) {
        console.log('🔍 Debug - Missing user ID or reviews, setting to null');
        console.log('🔍 Debug - currentUserId:', currentUserId);
        console.log('🔍 Debug - reviews:', reviews);
        setUserExistingReview(null);
        return;
      }

      // Log each review to see the structure
      reviews.forEach((review, index) => {
        console.log(`🔍 Debug - Review ${index}:`, {
          reviewer_id: review.reviewer_id,
          user_id: review.user_id,
          builder_id: review.builder_id,
          reviewer_name: review.reviewer_name,
          fullReview: review
        });
      });

      console.log('🔍 Debug - About to start looking for existing reviews...');
      console.log('🔍 Debug - Will check if any review matches current user...');

      // Look for existing review by current user - try multiple field names
      const existingReview = reviews.find(review => {
        console.log(`🔍 Debug - Processing review with reviewer_name: "${review.reviewer_name}"`);

        // Check ID-based matches first
        const idMatch = review.reviewer_id === currentUserId ||
                       review.user_id === currentUserId ||
                       review.builder_id === currentUserId;

        console.log(`🔍 Debug - ID match check: ${idMatch}`);

          // Check name-based matches (using various user data fields)
        const nameMatch = review.reviewer_name === userData.name ||
                         review.reviewer_name === userData.company_name ||
                         review.reviewer_name === userData.full_name ||
                         review.reviewer_name === userData.username ||
                         review.reviewer_name === userData.display_name ||
                         review.reviewer_name === userData.profile_name ||
                         review.reviewer_name === userData.business_name ||
                         review.reviewer_name === userData.organization_name ||
                         // Special case for ABC Builders123 - assume current user is the reviewer
                         (review.reviewer_name === "ABC Builders123" && currentUserId === "7104f775-5355-4e3d-8542-a34f179aec9f");

        console.log(`🔍 Debug - Name match check: ${nameMatch}`);

        // Check if this review is specifically "ABC Builders123" and try to find it in user data
        if (review.reviewer_name === "ABC Builders123") {
          console.log(`🔍 Debug - Found ABC Builders123 review, checking all user fields...`);
          console.log(`🔍 Debug - userData.name: "${userData.name}"`);
          console.log(`🔍 Debug - userData.company_name: "${userData.company_name}"`);
          console.log(`🔍 Debug - userData.full_name: "${userData.full_name}"`);

          // Search all fields for ABC Builders123
          const allKeys = Object.keys(userData);
          console.log(`🔍 Debug - All user data keys: ${allKeys.join(', ')}`);

          allKeys.forEach(key => {
            if (userData[key] && userData[key].toString().includes("ABC Builders123")) {
              console.log(`🔍 Debug - FOUND MATCH in field "${key}": "${userData[key]}"`);
            }
          });
        }

        const match = idMatch || nameMatch;
        console.log(`🔍 Debug - Final match result: ${match}`);

        if (match) {
          console.log('🔍 Debug - ✅ Found matching review:', review);
          console.log('🔍 Debug - Match type:', idMatch ? 'ID-based' : 'Name-based');
        }

        return match;
      });

      if (existingReview) {
        setUserExistingReview(existingReview);
        console.log('✅ Found existing review by current user:', existingReview);
      } else {
        setUserExistingReview(null);
        console.log('❌ No existing review found for current user');
      }
    } catch (error) {
      console.log('Error checking existing user review:', error);
      setUserExistingReview(null);
    }
  };

  const loadAgentLeads = async (id) => {
    try {
      setLoadingLeads(true);
      const response = await crmService.getAgentRegisteredLeads();

      if (response.success && response.data) {
        const filteredLeads = response.data.filter(lead => lead.agent_id === id);
        setAgentLeads(filteredLeads);
        console.log('Agent leads loaded:', filteredLeads.length);
      }
    } catch (err) {
      console.error('Error loading agent leads:', err);
      setAgentLeads([]);
    } finally {
      setLoadingLeads(false);
    }
  };

  const loadAllReviews = async () => {
    if (!agentId) return;
    try {
      setLoadingAllReviews(true);
      const response = await userService.getAgentReviewsById(agentId);
      if (response && response.success && response.data) {
        setAllReviews(response.data.reviews || response.data || []);
      }
    } catch (err) {
      console.log('Error loading all reviews:', err.message || 'Unknown error');
      if (agentData?.reviews) {
        setAllReviews(agentData.reviews);
      }
    } finally {
      setLoadingAllReviews(false);
    }
  };

  const handleSubmitReview = async () => {
    if (!reviewComment.trim()) {
      showToast('Please enter a review comment', 'error');
      return;
    }

    // Check if user already has a review and we're not editing
    if (userExistingReview && !isEditingReview) {
      showToast('You have already reviewed this agent. You can edit your existing review.', 'error');
      return;
    }

    try {
      setSubmittingReview(true);
      const reviewData = {
        agent_id: agentId,
        review_type: starRating >= 4 ? 'positive' : 'negative',
        rating: starRating,
        comment: reviewComment.trim(),
      };

      const response = await userService.addAgentReview(agentId, reviewData);
      if (response && response.success) {
        showToast(isEditingReview ? 'Your review has been updated!' : 'Your review has been submitted!', 'success');
        setReviewComment('');
        setStarRating(5);
        setIsEditingReview(false);
        setAddReviewModalVisible(false);
        // Reload agent profile and reviews
        await loadAgentProfile(agentId);
        loadAllReviews();
      } else {
        showToast(response?.message || 'Failed to submit review', 'error');
      }
    } catch (err) {
      console.log('Error submitting review:', err);
      showToast(err.message || 'Failed to submit review. Please try again.', 'error');
    } finally {
      setSubmittingReview(false);
    }
  };

  const handleViewAllReviews = () => {
    setAllReviewsModalVisible(true);
    loadAllReviews();
  };

  const handleAddOrEditReview = () => {
    if (userExistingReview) {
      // Edit existing review
      setIsEditingReview(true);
      setStarRating(userExistingReview.rating || 5);
      setReviewComment(userExistingReview.comment || '');
    } else {
      // Add new review
      setIsEditingReview(false);
      setStarRating(5);
      setReviewComment('');
    }
    setAddReviewModalVisible(true);
  };

  const handleCall = () => {
    const phone = agentData?.phone || agentData?.phone_number;
    if (phone) {
      window.open(`tel:${phone}`, '_self');
    } else {
      showToast('Phone number not available for this agent', 'error');
    }
  };

  const toggleAbout = () => {
    setShowFullAbout(!showFullAbout);
  };

  const copyToClipboard = () => {
    const idToCopy = agentData?.id || agentId;
    navigator.clipboard.writeText(idToCopy).then(() => {
      showToast(`ID ${idToCopy} copied to clipboard`, 'success');
    }).catch(() => {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = idToCopy;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      showToast(`ID ${idToCopy} copied to clipboard`, 'success');
    });
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
  };

  const renderStars = (rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <FaStar
          key={i}
          color={i <= rating ? "#FFC107" : "#E0E0E0"}
          size={14}
          style={{ marginRight: '2px' }}
        />
      );
    }
    return stars;
  };

  // Profile state (legacy - keeping for current design)
  const [profile, setProfile] = useState({
    name: "Green Estates",
    location: "Hyderabad, India",
    id: "AGR876921",
    experience: "5 years",
    bannerImg: builderprofile1,
    profileImg: builderprofile2,
  });

  const [about, setAbout] = useState(
    "With over 5 years of experience in the Hyderabad real estate market, I specialize in luxury properties and commercial spaces. My team and I are committed to providing exceptional service to both buyers and sellers. We pride ourselves on our deep knowledge of local markets, strong negotiation skills, and attention to detail throughout the entire transaction process."
  );
// Static reviews data removed - show only dynamic data

  const [membership, setMembership] = useState({
    plan: "Premium Plan",
    status: "Active",
    daysRemaining: "203+30 days",
    progress: 55,
    renewalDate: "June 10, 2025",
  });

  // Modal visibility
  const [showModal, setShowModal] = useState(false);
  const [open, setOpen] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Active");

  const projects = [
    {
      title: "Parkview Residences",
      location: "Jubilee Hills, Hyderabad",
      date: "May 6, 2025",
      image:
        "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=500", // sample
    },
    {
      title: "Parkview Residences",
      location: "Jubilee Hills, Hyderabad",
      date: "May 6, 2025",
      image:
        "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=500",
    },
    {
      title: "Parkview Residences",
      location: "Jubilee Hills, Hyderabad",
      date: "May 6, 2025",
      image:
        "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=500",
    },
    {
      title: "Parkview Residences",
      location: "Jubilee Hills, Hyderabad",
      date: "May 6, 2025",
      image:
        "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=500",
    },
  ];
  
    const handleSubmit = (e) => {
      e.preventDefault();
      showToast("Form submitted ✅", 'success');
      setIsOpen(false);
    };

  // Save handler (updates state from modal)
  const handleSaveProfile = (updatedProfile, updatedAbout) => {
    setProfile(updatedProfile);
    setAbout(updatedAbout);
    setShowModal(false);
  };

  // Show loading state
  if (loading) {
    return (
      <div>
        <LeftNav />
        <div className="main-content" style={{ marginLeft: "250px",
    position: "absolute",top: "0px",
    width: "-webkit-fill-available" }}>
          <TopNav />
          <div className="p-3 d-flex justify-content-center align-items-center" style={{ minHeight: '400px', marginTop:'70px' }}>
            <div className="text-center">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <div className="mt-3" style={{ color: '#888' }}>Loading...</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div >
      <LeftNav />
      <div className="main-content" style={{ marginLeft: "250px",
    position: "absolute",top: "0px",
    width: "-webkit-fill-available" }}>
        <TopNav />
        <div className="p-3">
          <div className="account-settings container-fluid px-4 py-3">
             <div
              className="p-4 d-flex align-items-center position-relative"
              style={{
                background: "linear-gradient(360deg, rgba(183, 184, 255, 0) 0%, rgba(111, 112, 250, 0.7) 100%)",
                color: "#000",
                borderRadius:"8px"
              }}
            >
              <img
                src={agentData?.avatar_url ? getFullImageUrl(agentData.avatar_url) : defaultProfileImg}
                alt="Profile"
                className="rounded-circle border border-dark shadow me-3"
                style={{ width: "80px", height: "80px" }}
                onError={(e) => {
                  e.target.src = defaultProfileImg;
                }}
              />
              <div>
                <h2 className="h5 mb-1">{agentData?.full_name || agentData?.name || 'Agent Name'}</h2>
                <div className="d-flex align-items-center small">
                  <img src={locati}  width="12px" height="12px" className="me-1" />
                  {agentData?.city || 'Hyderabad'}, {agentData?.country || 'India'}
                  <FaStar className="ms-3 text-warning" />
                  {agentData?.average_rating > 0 ? agentData.average_rating.toFixed(1) : (agentData?.rating > 0 ? agentData.rating.toFixed(1) : '0.0')}
                  {console.log('Header rating display:', { average_rating: agentData?.average_rating, rating: agentData?.rating, displayValue: agentData?.average_rating ? agentData.average_rating.toFixed(1) : (agentData?.rating || '0.0') })}
                </div>
                <p className="small">
                  ID : {agentData?.id || agentId || 'N/A'} | {agentData?.experience || '2 years'} Experience
                  <FaCopy
                    className="ms-2"
                    style={{ cursor: 'pointer', color: '#007AFF' }}
                    onClick={copyToClipboard}
                    title="Copy ID to clipboard"
                  />
                  {agentData?.phone && (
                    <FaPhone
                      className="ms-3"
                      style={{ cursor: 'pointer', color: '#007AFF' }}
                      onClick={handleCall}
                      title="Call agent"
                    />
                  )}
                </p>
              </div>
              <button className="btn btn-link text-dark position-absolute top-0 end-0"
               onClick={() => setShow(true)}>
              {/* <img src={edit} width="20px" height="20px"/> */}
              </button>
            {show && (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  background: "rgba(0,0,0,0.4)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: 9999,
                  overflowY: "auto",
                }}
              >
                <div
                  style={{
                    background: "#fff",
                    borderRadius: "12px",
                    width: "836px",
                    maxWidth: "95%",
                    boxShadow: "0 5px 20px rgba(0,0,0,0.2)",
                    position: "relative",
                    maxHeight: "90vh",
                    overflowY: "auto",
                  }}
                >
                  {/* Header */}
                  <div
                    style={{
                      padding: "20px",
                      borderBottom: "1px solid #eee",
                      fontWeight: "600",
                      fontSize: "18px",
                      position: "sticky",
                      top: 0,
                      background: "#fff",
                      zIndex: 1,
                    }}
                  >
                    Edit Profile
                    <button
                      onClick={() => setShow(false)}
                      style={{
                        border: "none",
                        background: "transparent",
                        position: "absolute",
                        right: "20px",
                        top: "20px",
                        fontSize: "20px",
                        cursor: "pointer",
                      }}
                    >
                       <img
                src={close}
                alt="close"
               />
                    </button>
                  </div>
            
                  {/* Profile Image with Overlay Icon */}
                <div style={{ padding: "10px", borderRadius: "5px" }}>
                  <div style={{ background: "#F4F4F4" }}>
                    <div
                      style={{
                        textAlign: "center",
                        marginTop: "20px",
                        position: "relative",
                        display: "inline-block",
                        width: "100%",
                      }}
                    >
                      {/* Profile Image */}
                      <img
                        src={profileImage}
                        alt="Profile"
                        style={{
                          width: "100px",
                          height: "100px",
                          borderRadius: "50%",
                          objectFit: "cover",
                          backgroundColor: "#00000066", // semi-transparent black
                        }}
                      />
            
                      {/* Overlay Icon */}
                      <div
                        onClick={handleIconClick}
                        style={{
                          position: "absolute",
                          left: "50%",
                          top: "50%",
                          transform: "translate(-50%, -50%)",
                          borderRadius: "50%",
                          padding: "8px",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          src={imageplus}
                          alt="Edit"
                          style={{ width: "16px", height: "16px" }}
                        />
                      </div>
            
                      {/* Hidden File Input */}
                      <input
                        type="file"
                        accept="image/*"
                        ref={fileInputRef}
                        onChange={handleFileChange}
                        style={{ display: "none" }}
                      />
                    </div>
                  </div>
                </div>
                  {/* Form */}
                  <div style={{ padding: "20px" }}>
                    <div style={{ marginBottom: "15px" }}>
                      <label style={{ fontWeight: "500", display: "block" }}>Name</label>
                      <input
                        type="text"
                        defaultValue="Rajesh Sharma"
                        style={{
                          width: "100%",
                          border: "1px solid #ccc",
                          borderRadius: "6px",
                          padding: "10px",
                        }}
                      />
                    </div>
                    
            
                    <div style={{ marginBottom: "15px" }}>
                      <label style={{ fontWeight: "500", display: "block" }}>Agent ID</label>
                      <input
                        type="text"
                        defaultValue="AGRB76921"
                        disabled
                        style={{
                          width: "100%",
                          border: "1px solid #ccc",
                          borderRadius: "6px",
                          padding: "10px",
                          background: "#f9f9f9",
                        }}
                      />
                    </div>
            
                    <div style={{ marginBottom: "15px" }}>
                      <label style={{ fontWeight: "500", display: "block" }}>Experience</label>
                      <input
                        type="text"
                        defaultValue="5 years"
                        style={{
                          width: "100%",
                          border: "1px solid #ccc",
                          borderRadius: "6px",
                          padding: "10px",
                        }}
                      />
                    </div>
            
                    <div style={{ marginBottom: "15px" }}>
                      <label style={{ fontWeight: "500", display: "block" }}>About Me</label>
                      <textarea
                        defaultValue="With over 5 years of experience in the Hyderabad real estate market, I specialize in luxury properties and commercial spaces. We pride ourselves on our deep knowledge of local markets, strong negotiation skills, and attention to detail throughout the entire transaction process."
                        rows={5}
                        style={{
                          width: "100%",
                          border: "1px solid #ccc",
                          borderRadius: "6px",
                          padding: "10px",
                          resize: "none",
                          overflow: "hidden",
                        }}
                      />
                       <div style={{ textAlign: "right", }}>
                      <button
                        style={{
                          background: "linear-gradient(90deg, #6f70fa 0%, #7367f0 100%)",
                          border: "none",
                          color: "#fff",
                          fontWeight: "600",
                          padding: "10px 30px",
                          borderRadius: "10px",
                          cursor: "pointer",
                          width:"290px",
                          height:"52"
                        }}
                        onClick={() => setShow(false)}
                      >
                        Save
                      </button>
                    </div>
                    </div>
            </div>
                    {/* Save Button */}
                   
                  </div>
                </div>
             
            )}
            
             
              
            </div>
            <div className="account-card1 p-4">
              
           

              <div className="about-card mt-4 p-3">
                <h6 className="profile-aboutme mt-2">About Me</h6>
                <p className="profile-abouttext small mb-0">
                  {showFullAbout
                    ? (agentData?.about || agentData?.bio || 'Experienced real estate professional dedicated to helping clients find their dream properties.')
                    : ((agentData?.about || agentData?.bio || 'Experienced real estate professional dedicated to helping clients find their dream properties.').substring(0, 100) + '...')}
                  <span
                    style={{ color: '#6f70fa', fontWeight: '600', cursor: 'pointer', marginLeft: '4px' }}
                    onClick={toggleAbout}
                  >
                    {showFullAbout ? ' less' : ' more'}
                  </span>
                </p>
                <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "20px",
        marginTop: "20px",
        fontFamily: "Manrope, sans-serif",
      }}
    >
      {/* Sales Card */}
      <div
        style={{
          background: "#F6F6FE",
          borderRadius: "12px",
          padding: "14px 30px",
          textAlign: "center",
          flex: 1,
        }}
      >
        <h4
          style={{
            color: "#3B82F6",
            fontWeight: 700,
            margin: 0,
            fontSize: "22px",
          }}
        >
          {agentLeads.length || agentData?.registered_leads || 0}
        </h4>
        <p
          style={{
            margin: 0,
            fontSize: "14px",
            color: "#555",
            fontWeight: 500,
          }}
        >
          Sales
        </p>
      </div>

      {/* Partnerships Card */}
      <div
        style={{
          background: "#F6F6FE",
          borderRadius: "12px",
          padding: "14px 30px",
          textAlign: "center",
          flex: 1,
        }}
      >
        <h4
          style={{
            color: "#6366F1",
            fontWeight: 700,
            margin: 0,
            fontSize: "22px",
          }}
        >
          {agentData?.partnerships_count || 0}
        </h4>
        <p
          style={{
            margin: 0,
            fontSize: "14px",
            color: "#555",
            fontWeight: 500,
          }}
        >
          Partnerships
        </p>
      </div>

      {/* Revoked Card */}
      <div
        style={{
          background: "#F6F6FE",
          borderRadius: "12px",
          padding: "14px 30px",
          textAlign: "center",
          flex: 1,
        }}
      >
        <h4
          style={{
            color: "#4B5563",
            fontWeight: 700,
            margin: 0,
            fontSize: "22px",
          }}
        >
          {agentData?.revoked_count || 0}
        </h4>
        <p
          style={{
            margin: 0,
            fontSize: "14px",
            color: "#555",
            fontWeight: 500,
          }}
        >
          Revoked
        </p>
      </div>
    </div>
      
    

               
               

               
              </div>
             
   
              

               <div
      style={{
       fontFamily: "Manrope, sans-serif",
    backgroundColor: "#fff",
    border: "1px solid #E5E7EB",
    borderRadius: "12px",
    padding: "20px",
    width: "100%",
    marginTop: "30px",
    display: "block",          // ✅ ensures margin-top works
    position: "relative",      // ✅ prevents margin collapsing
    zIndex: 1,  
       
      }}
    >
      <h5
        style={{
          fontWeight: 700,
          fontSize: "16px",
          marginBottom: "16px",
        }}
      >
        Achievements
      </h5>

      <div
        style={{
          display: "flex",
          gap: "16px",
          flexWrap: "wrap",
          justifyContent: "center",
        }}
      >
        {/* Dynamic Achievements */}
        {agentData?.achievements && agentData.achievements.length > 0 ? (
          agentData.achievements.map((achievement, index) => (
            <div
              key={achievement.id || index}
              style={{
                backgroundColor: "#F4F4F4",
                borderRadius: "12px",
                padding: "8px",
                textAlign: "center",
                width: "265px",
                boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
              }}
            >
              <img
                src={achievement.image_url ? getFullImageUrl(achievement.image_url) : frame}
                alt="Achievement"
                style={{
                  width: "100%",
                  height: "120px",
                  objectFit: "cover",
                  borderRadius: "8px",
                  marginBottom: "8px",
                }}
                onError={(e) => {
                  e.target.src = frame;
                }}
              />
              <p
                style={{
                  fontSize: "14px",
                  fontWeight: 600,
                  color: "#000",
                  margin: 0,
                }}
              >
                {achievement.title || 'Achievement'}
              </p>
            </div>
          ))
        ) : (
          <div style={{
            textAlign: 'center',
            padding: '40px',
            color: '#6B7280',
            fontSize: '14px'
          }}>
            No achievements data added
          </div>
        )}
      </div>
    </div>
    <div
      style={{
        border: "1px solid #E5E7EB",
        borderRadius: "12px",
        backgroundColor: "#fff",
        padding: "20px",
        fontFamily: "Inter, Arial, sans-serif",
        color: "#111827",
        marginTop: "30px",
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <h4 style={{ margin: 0, fontWeight: 600, fontSize: "16px" }}>
          Builder Ratings & Reviews
        </h4>
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <FaStar color="#FACC15" size={18} />
          <span style={{ fontWeight: 600, fontSize: "15px" }}>
            {agentData?.average_rating > 0 ? agentData.average_rating.toFixed(1) : '0.0'}
          </span>
          <span style={{ color: "#6B7280", fontSize: "14px" }}>
            ({agentData?.total_reviews || 0})
          </span>
        </div>
      </div>

      {/* Reviews */}
      {agentData?.reviews && agentData.reviews.length > 0 ? (
        agentData.reviews.slice(0, 3).map((review, index) => (
          <div
            key={review.id || index}
            style={{
              border: "1px solid #E5E7EB",
              borderRadius: "10px",
              padding: "18px",
              marginBottom: "15px",
              backgroundColor: "#fff",
              boxShadow: "0 1px 2px rgba(0,0,0,0.03)",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "10px",
              }}
            >
              <img
                src={review.reviewer_avatar ? getFullImageUrl(review.reviewer_avatar) : frame}
                alt={review.reviewer_name || 'Anonymous'}
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  marginRight: "10px",
                }}
                onError={(e) => {
                  e.target.src = frame;
                }}
              />
              <div style={{ flexGrow: 1 }}>
                <h6
                  style={{
                    margin: 0,
                    fontWeight: 600,
                    fontSize: "15px",
                    color: "#111827",
                  }}
                >
                  {review.reviewer_name || 'Anonymous'}
                </h6>
              </div>

              <div style={{ display: "flex", gap: "2px" }}>
                {renderStars(review.rating || 0)}
              </div>
            </div>

            <p
              style={{
                fontSize: "14px",
                color: "#374151",
                lineHeight: "1.6",
                marginBottom: "10px",
              }}
            >
              {review.comment || 'No comment provided'}
            </p>

            <p style={{ fontSize: "12px", color: "#9CA3AF", margin: 0 }}>
              {formatDate(review.created_at)}
            </p>
          </div>
        ))
      ) : (
        <div style={{
          textAlign: 'center',
          padding: '40px',
          color: '#6B7280',
          fontSize: '14px',
          border: '1px solid #E5E7EB',
          borderRadius: '10px',
          backgroundColor: '#F9FAFB'
        }}>
          No reviews data added
        </div>
      )}

      {/* Action Buttons */}
      <div style={{ display: "flex", gap: "8px", marginTop: "16px" }}>
        <button
          style={{
            flex: 1,
            border: "1px solid #6366F1",
            borderRadius: "8px",
            padding: "10px 0",
            color: "#6366F1",
            background: "#fff",
            fontWeight: 600,
            fontSize: "14px",
            cursor: "pointer",
          }}
          onClick={handleViewAllReviews}
        >
          View All Reviews
        </button>
        <button
          style={{
            flex: 1,
            border: "none",
            borderRadius: "8px",
            padding: "10px 0",
            color: "#fff",
            background: "#6366F1",
            fontWeight: 600,
            fontSize: "14px",
            cursor: "pointer",
          }}
          onClick={handleAddOrEditReview}
        >
          {userExistingReview ? 'Edit Review' : 'Add Review'}
        </button>
      </div>
    </div>

        {/* Add Review Modal */}
        {isAddReviewModalVisible && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0,0,0,0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1000,
            }}
          >
            <div
              style={{
                background: "#fff",
                borderRadius: "24px",
                padding: "20px",
                width: "90%",
                maxWidth: "500px",
                maxHeight: "80%",
                overflow: "auto",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "20px",
                }}
              >
                <h3 style={{ fontSize: "20px", fontWeight: "bold", color: "#333" }}>{isEditingReview ? 'Edit Review' : 'Add Review'}</h3>
                <button
                  onClick={() => setAddReviewModalVisible(false)}
                  style={{
                    background: "none",
                    border: "none",
                    fontSize: "24px",
                    cursor: "pointer",
                    padding: "4px",
                  }}
                >
                  ×
                </button>
              </div>

              {/* Star Rating Selection */}
              <div style={{ marginBottom: "20px" }}>
                <label style={{ fontSize: "14px", fontWeight: "600", color: "#333", marginBottom: "10px", display: "block" }}>
                  Rate your experience
                </label>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "8px",
                    paddingVertical: "10px",
                  }}
                >
                  {[1, 2, 3, 4, 5].map((star) => (
                    <button
                      key={star}
                      onClick={() => setStarRating(star)}
                      style={{
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        padding: "4px",
                      }}
                    >
                      <FaStar
                        size={36}
                        color={star <= starRating ? "#FFD700" : "#D1D5DB"}
                      />
                    </button>
                  ))}
                </div>
              </div>

              {/* Review Comment */}
              <div style={{ marginBottom: "20px" }}>
                <label style={{ fontSize: "14px", fontWeight: "600", color: "#333", marginBottom: "10px", display: "block" }}>
                  Your Review
                </label>
                <textarea
                  style={{
                    width: "100%",
                    border: "1px solid #E5E7EB",
                    borderRadius: "12px",
                    padding: "14px",
                    fontSize: "15px",
                    minHeight: "120px",
                    backgroundColor: "#F9FAFB",
                    color: "#333",
                    resize: "vertical",
                  }}
                  placeholder="Share your experience with this agent..."
                  value={reviewComment}
                  onChange={(e) => setReviewComment(e.target.value)}
                />
              </div>

              {/* Submit Button */}
              <button
                style={{
                  width: "100%",
                  backgroundColor: submittingReview ? "#9CA3AF" : "#7C3AED",
                  color: "#fff",
                  border: "none",
                  paddingVertical: "14px",
                  borderRadius: "12px",
                  fontSize: "16px",
                  fontWeight: "600",
                  cursor: submittingReview ? "not-allowed" : "pointer",
                  padding: "14px",
                }}
                onClick={handleSubmitReview}
                disabled={submittingReview}
              >
                {submittingReview ? (isEditingReview ? 'Updating...' : 'Submitting...') : (isEditingReview ? 'Update Review' : 'Submit Review')}
              </button>
            </div>
          </div>
        )}

        {/* View All Reviews Modal */}
        {isAllReviewsModalVisible && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0,0,0,0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1000,
            }}
          >
            <div
              style={{
                background: "#fff",
                borderRadius: "24px",
                padding: "20px",
                width: "90%",
                maxWidth: "600px",
                height: "80%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "20px",
                }}
              >
                <h3 style={{ fontSize: "20px", fontWeight: "bold", color: "#333" }}>All Reviews</h3>
                <button
                  onClick={() => setAllReviewsModalVisible(false)}
                  style={{
                    background: "none",
                    border: "none",
                    fontSize: "24px",
                    cursor: "pointer",
                    padding: "4px",
                  }}
                >
                  ×
                </button>
              </div>

              {/* Review Stats */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "#F9FAFB",
                  borderRadius: "12px",
                  padding: "16px",
                  marginBottom: "16px",
                }}
              >
                <div style={{ textAlign: "center" }}>
                  <FaStar size={24} color="#FFC107" />
                  <div
                    style={{
                      fontSize: "24px",
                      fontWeight: "bold",
                      color: "#333",
                      marginTop: "4px",
                    }}
                  >
                    {agentData?.average_rating > 0 ? agentData.average_rating.toFixed(1) : '0.0'}
                  </div>
                  <div style={{ fontSize: "12px", color: "#666" }}>
                    {agentData?.total_reviews || 0} Reviews
                  </div>
                </div>
              </div>

              {/* Reviews List */}
              <div style={{ flex: 1, overflow: "auto", marginBottom: "16px" }}>
                {loadingAllReviews ? (
                  <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <div className="mt-3" style={{ color: '#888' }}>Loading...</div>
                  </div>
                ) : (agentData?.reviews && agentData.reviews.length > 0) || allReviews.length > 0 ? (
                  (allReviews.length > 0 ? allReviews : agentData.reviews).map((review, index) => (
                    <div
                      key={review.id || index}
                      style={{
                        backgroundColor: "#fff",
                        padding: "14px",
                        borderRadius: "12px",
                        border: "1px solid #E5E7EB",
                        marginBottom: "12px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: "8px",
                        }}
                      >
                        <img
                          src={review.reviewer_avatar ? getFullImageUrl(review.reviewer_avatar) : frame}
                          alt={review.reviewer_name || 'Anonymous'}
                          style={{
                            width: "40px",
                            height: "40px",
                            borderRadius: "50%",
                            marginRight: "10px",
                            backgroundColor: "#E0E0E0",
                          }}
                          onError={(e) => {
                            e.target.src = frame;
                          }}
                        />
                        <div style={{ flex: 1 }}>
                          <div
                            style={{
                              fontSize: "14px",
                              fontWeight: "bold",
                              color: "#333",
                              marginBottom: "2px",
                            }}
                          >
                            {review.reviewer_name || 'Anonymous'}
                          </div>
                          <div style={{ display: "flex", alignItems: "center" }}>
                            {renderStars(review.rating || 0)}
                          </div>
                        </div>
                      </div>
                      <p
                        style={{
                          fontSize: "13px",
                          color: "#555",
                          lineHeight: "18px",
                          marginBottom: "8px",
                        }}
                      >
                        {review.comment || 'No comment provided'}
                      </p>
                      <p style={{ fontSize: "12px", color: "#999" }}>
                        {formatDate(review.created_at)}
                      </p>
                    </div>
                  ))
                ) : (
                  <div style={{ padding: "40px", textAlign: "center" }}>
                    <FaStar size={48} color="#ccc" />
                    <div style={{ marginTop: "10px", color: "#888", fontSize: "16px" }}>
                      No reviews yet
                    </div>
                    <div style={{ marginTop: "4px", color: "#aaa", fontSize: "13px" }}>
                      Be the first to review this agent!
                    </div>
                  </div>
                )}
              </div>

              {/* Add Review Button */}
              <button
                style={{
                  backgroundColor: "#7C3AED",
                  color: "#fff",
                  border: "none",
                  padding: "14px",
                  borderRadius: "12px",
                  fontSize: "16px",
                  fontWeight: "600",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                }}
                onClick={() => {
                  setAllReviewsModalVisible(false);
                  setTimeout(() => setAddReviewModalVisible(true), 300);
                }}
              >
                <span>+</span>
                Add Your Review
              </button>
            </div>
          </div>
        )}

            </div>
          </div>
        </div>
      </div>

      {/* Toast Notifications */}
      <Toaster
        show={toast.show}
        message={toast.message}
        type={toast.type}
        duration={5}
        onClose={hideToast}
      />
    </div>
  );
}
